// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Squad In Touch — Typography tokens
   The legacy app shipped system / Helvetica fonts only.
   We adopt a clean, professional, data-friendly stack:
     Display  — Hanken Grotesk (warm geometric, headings + big numbers)
     UI/Body  — Public Sans  (neutral, legible at 13–14px, tabular figures)
     Mono     — JetBrains Mono (IDs, scores, codes)
   ============================================================ */

:root {
  --font-display: 'Hanken Grotesk', 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif;
  --font-sans:    'Public Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  --font-mono:    'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace;

  /* type scale (px-based, data-dense UI) */
  --text-2xs: 11px;
  --text-xs:  12px;
  --text-sm:  13px;   /* table cells, secondary UI */
  --text-md:  14px;   /* default body / controls */
  --text-lg:  16px;
  --text-xl:  18px;
  --text-2xl: 22px;
  --text-3xl: 28px;
  --text-4xl: 34px;
  --text-5xl: 44px;

  /* line heights */
  --leading-tight:   1.15;
  --leading-snug:    1.3;
  --leading-normal:  1.5;
  --leading-relaxed: 1.65;

  /* weights */
  --weight-regular:  400;
  --weight-medium:   500;
  --weight-semibold: 600;
  --weight-bold:     700;
  --weight-extra:    800;

  /* letter spacing */
  --tracking-tight:  -0.012em;
  --tracking-normal: 0;
  --tracking-wide:   0.04em;
  --tracking-caps:   0.06em;  /* uppercase eyebrows / labels */

  /* semantic type roles */
  --font-heading: var(--font-display);
  --font-body:    var(--font-sans);
  --font-data:    var(--font-mono);
}
`, "",{"version":3,"sources":["webpack://./src/styles/squad-theme/tokens/typography.css"],"names":[],"mappings":"AAAA;;;;;;;iEAOiE;;AAEjE;EACE,iGAAiG;EACjG,uFAAuF;EACvF,qFAAqF;;EAErF,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB,IAAI,8BAA8B;EAClD,gBAAgB,IAAI,4BAA4B;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;;EAEvB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB,GAAG,gCAAgC;;EAE5D,wBAAwB;EACxB,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;AAClC","sourcesContent":["/* ============================================================\n   Squad In Touch — Typography tokens\n   The legacy app shipped system / Helvetica fonts only.\n   We adopt a clean, professional, data-friendly stack:\n     Display  — Hanken Grotesk (warm geometric, headings + big numbers)\n     UI/Body  — Public Sans  (neutral, legible at 13–14px, tabular figures)\n     Mono     — JetBrains Mono (IDs, scores, codes)\n   ============================================================ */\n\n:root {\n  --font-display: 'Hanken Grotesk', 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif;\n  --font-sans:    'Public Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;\n  --font-mono:    'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace;\n\n  /* type scale (px-based, data-dense UI) */\n  --text-2xs: 11px;\n  --text-xs:  12px;\n  --text-sm:  13px;   /* table cells, secondary UI */\n  --text-md:  14px;   /* default body / controls */\n  --text-lg:  16px;\n  --text-xl:  18px;\n  --text-2xl: 22px;\n  --text-3xl: 28px;\n  --text-4xl: 34px;\n  --text-5xl: 44px;\n\n  /* line heights */\n  --leading-tight:   1.15;\n  --leading-snug:    1.3;\n  --leading-normal:  1.5;\n  --leading-relaxed: 1.65;\n\n  /* weights */\n  --weight-regular:  400;\n  --weight-medium:   500;\n  --weight-semibold: 600;\n  --weight-bold:     700;\n  --weight-extra:    800;\n\n  /* letter spacing */\n  --tracking-tight:  -0.012em;\n  --tracking-normal: 0;\n  --tracking-wide:   0.04em;\n  --tracking-caps:   0.06em;  /* uppercase eyebrows / labels */\n\n  /* semantic type roles */\n  --font-heading: var(--font-display);\n  --font-body:    var(--font-sans);\n  --font-data:    var(--font-mono);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
